import {
  Box,
  Button,
  Center,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Switch,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { useDeleteCourseChangeAlertInputMutation } from "./index.generated";
import { useEffect } from "react";

export const DeleteRouteChangeAlertBox = ({
  isShowBox,
  courseId,
  isMapDarkMode,
  setIsMapDarkMode,
}: {
  isShowBox: boolean;
  courseId: string;
  isMapDarkMode: boolean;
  setIsMapDarkMode: (value: boolean) => void;
}) => {
  const toast = useToast();
  const {
    isOpen: isOpenCaution,
    onOpen: onOpenCaution,
    onClose: onCloseCaution,
  } = useDisclosure();
  const {
    isOpen: isOpenResult,
    onOpen: onOpenResult,
    onClose: onCloseResult,
  } = useDisclosure();

  const [resp, deleteCourseChangeAlert] =
    useDeleteCourseChangeAlertInputMutation();

  useEffect(() => {
    if (resp.data) {
      onOpenResult();
    }
  }, [resp.data]);
  return (
    <>
      <DeleteRouteChangeAlertCautionModal
        isOpen={isOpenCaution}
        onClose={onCloseCaution}
        onClickCancel={onCloseCaution}
        onClickSubmit={() => {
          deleteCourseChangeAlert(
            { input: { courseId: courseId } },
            { additionalTypenames: ["Course"] }
          );
          setIsMapDarkMode(false);
          onCloseCaution();
        }}
      />
      <DeleteRouteChangeAlertResultModal
        isOpen={isOpenResult}
        onClose={onCloseResult}
      />
      {isShowBox && (
        <Box bg="#CC3D49" rounded={10} p={2}>
          <Flex alignItems="center" m={2}>
            <Box fontWeight={600} color="#FFFFFF" fontSize={16}>
              <Text>地図の変更により、</Text>
              <Text>経路が変更されました。</Text>
            </Box>
            <Box px={4} py={2} rounded={2} bg={"#FFFFFF"} flexShrink={0}>
              <Center flexDir="column">
                <Box bg="#FF8EFB" rounded={10} m={2} w={10} height={2} />
                <Text color="#000000" fontSize={12}>
                  変更前経路
                </Text>
              </Center>
            </Box>
          </Flex>
          <Text color="#FFFFFF">経路誘導用スポットを追加して、</Text>
          <Text color="#FFFFFF">経路を修正してください。</Text>
          <Flex gap={2} my={2}>
            <Button
              onClick={() => {
                setIsMapDarkMode(!isMapDarkMode);
              }}
              bg="transparent"
              color="#FFFFFF"
              borderWidth={1}
              borderColor="#FFFFFF"
              borderRadius={100}
              flex={2}
            >
              {isMapDarkMode ? "地図を戻す" : "変化を見やすくする"}
            </Button>
            <Button
              onClick={onOpenCaution}
              flex={1}
              borderWidth={0}
              borderRadius={100}
            >
              修正完了
            </Button>
          </Flex>
        </Box>
      )}
    </>
  );
};

const DeleteRouteChangeAlertCautionModal = ({
  isOpen,
  onClose,
  onClickCancel,
  onClickSubmit,
}: {
  isOpen: boolean;
  onClose: () => void;
  onClickCancel: () => void;
  onClickSubmit: () => void;
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent color="#FFFFFF" bgColor="#071223" py={3} px={6}>
        <ModalHeader>
          <Center>経路の修正を完了しますか。</Center>
        </ModalHeader>
        <ModalBody>
          <Text>
            完了を押すと変更前のルートや、アラートが表示されなくなります。
          </Text>
        </ModalBody>
        <Flex justifyContent="center" gap={4}>
          <Button
            w={100}
            mr={3}
            onClick={onClickCancel}
            bg="transparent"
            borderColor="#FFFFFF"
            borderWidth={1}
            borderRadius={100}
          >
            戻る
          </Button>
          <Button
            w={100}
            bg="#FFFFFF"
            color="#071223"
            borderRadius={100}
            onClick={onClickSubmit}
          >
            修正完了
          </Button>
        </Flex>
      </ModalContent>
    </Modal>
  );
};

const DeleteRouteChangeAlertResultModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent color="#FFFFFF" bgColor="#071223" py={3} px={6}>
        <ModalHeader>
          <Center>修正内容を保存しました。</Center>
        </ModalHeader>
        <ModalBody>
          <Text>
            SUBAROAD本体に反映する場合は、CSVで出力して制作会社に変更を依頼してください。
          </Text>
          <Text>CSVは、左下のボタンから出力できます。</Text>
        </ModalBody>
        <Center my={5}>
          <Button
            w={100}
            mr={3}
            onClick={onClose}
            bg="#FFFFFF"
            color="#071223"
            borderRadius={100}
            fontWeight={600}
          >
            閉じる
          </Button>
        </Center>
      </ModalContent>
    </Modal>
  );
};
